import { Injectable } from '@angular/core';

interface Draft {
  content: string;
  files: File[];
}

@Injectable({
  providedIn: 'root'
})
export class DraftService {

  private drafts = new Map<string, Draft>();

  saveDraft(conversationId: string, content: string, files: File[] = []): void {
    const hasContent = !!content?.trim();
    const hasFiles = files.length > 0;
    if (hasContent || hasFiles) {
      this.drafts.set(conversationId, { content: hasContent ? content : '', files: [...files] });
    } else {
      this.drafts.delete(conversationId);
    }
  }

  getDraft(conversationId: string): string {
    return this.drafts.get(conversationId)?.content || '';
  }

  getDraftFiles(conversationId: string): File[] {
    const files = this.drafts.get(conversationId)?.files;
    return files ? [...files] : [];
  }

  /** Any conversation holds unsent text or files (kept in memory only: a reload loses them). */
  hasDrafts(): boolean {
    return this.drafts.size > 0;
  }

  clearDraft(conversationId: string): void {
    this.drafts.delete(conversationId);
  }
}
